module.exports = __webpack_public_path__ + "static/media/icona_gruppi.c5217b46.svg";